import React from "react";
import PublicRoute from "../components/common/PublicRoute";

// Lazy load auth page components
const LoginPage = React.lazy(() => import("../pages/auth/LoginPage"));
const RegisterPage = React.lazy(() => import("../pages/auth/RegisterPage"));
const ForgotPasswordPage = React.lazy(() =>
    import("../pages/auth/ForgotPasswordPage")
);
const VerifyOtpPage = React.lazy(() => import("../pages/auth/VerifyOtpPage"));
const SetNewPasswordPage = React.lazy(() =>
    import("../pages/auth/SetNewPasswordPage")
);

// Export route configuration array
export const authRoutes = [
    {
        path: "/login",
        element: (
            <PublicRoute redirectTo="/admin">
                <LoginPage />
            </PublicRoute>
        ),
    },
    {
        path: "/register",
        element: (
            <PublicRoute redirectTo="/admin">
                <RegisterPage />
            </PublicRoute>
        ),
    },
    {
        path: "/forgot-password",
        element: (
            <PublicRoute redirectTo="/admin">
                <ForgotPasswordPage />
            </PublicRoute>
        ),
    },
    {
        path: "/verify-otp",
        element: (
            <PublicRoute redirectTo="/admin">
                <VerifyOtpPage />
            </PublicRoute>
        ),
    },
    {
        path: "/set-new-password",
        element: (
            <PublicRoute redirectTo="/admin">
                <SetNewPasswordPage />
            </PublicRoute>
        ),
    },
];